<template>
  <section class="landing-hero">
    <div class="landing-container">
      <div class="landing-hero-grid">
        <!-- Left Content -->
        <div class="landing-hero-text">
          <div class="landing-tagline">State Wildlife Network</div>
          <h1 class="landing-hero-title">
            Coexisting Safely,<br />
            <span>Protecting Wildlife.</span>
          </h1>
          <p class="landing-hero-desc">
            SARPA (Snake Awareness, Rescue and Protection App) is Madhya Pradesh's official system linking citizens with certified resources to resolve snake conflicts humanely, safely, and scientifically.
         </p>
          <div class="landing-hero-actions d-flex flex-wrap justify-center justify-md-start" style="gap: 16px;">
            <!-- <a href="#" class="landing-btn">
              <v-icon left size="20" color="white">mdi-apple</v-icon>
              App Store
            </a> -->

            <a href="https://play.google.com/store/apps/details?id=com.sarpamp.leopard&hl=en_IN" target="_blank" class="landing-btn">
              <v-icon left size="20" color="white">mdi-google-play</v-icon>
              Play Store
            </a>
          </div>

        </div>

        <!-- Right Image -->
        <div class="landing-hero-img-container">
          <img :src="require('@/assets/images/landing/1.png')" alt="Wildlife Protection" class="landing-hero-img" />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'AppHero'
};
</script>
